import React from 'react'

import CantileverButton from './CantileverButton'
import { Popup } from './Popup'

interface ConfirmDeletePopupProps {
  entityName: string
  popupPosition: { top: number; left: number }
  cancelDelete: () => void
  confirmDelete: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  deleteMessage?: string
}

export const ConfirmDeletePopup: React.FC<ConfirmDeletePopupProps> = ({
  entityName,
  popupPosition,
  deleteMessage,
  cancelDelete,
  confirmDelete,
}) => {
  return (
    <Popup
      position={popupPosition}
      message={deleteMessage ?? `Delete this ${entityName}?`}
      actions={
        <>
          <CantileverButton danger onClick={confirmDelete}>
            Delete
          </CantileverButton>
          <CantileverButton onClick={cancelDelete}>Cancel</CantileverButton>
        </>
      }
    />
  )
}
